export default __webpack_public_path__ + "static/whatIsPeBG-aee026dad47bb4a7b2aad5143eadbf5c.jpg";